import { Link } from 'react-router-dom';
import { Card, CardContent } from '../ui/card';
import { 
  Users, TrendingUp, Wallet, BarChart3, Clock, Settings, Gift, 
  FileSpreadsheet, Scale, Bell, ChevronRight, UserCheck, UserPlus, CreditCard, Calculator, IdCard
} from 'lucide-react';

/**
 * Admin quick links grid component
 */
export const AdminQuickLinks = ({ hasPermission }) => {
  const links = [
    {
      title: 'User Management',
      description: 'View all users & balances',
      icon: Users,
      iconBg: 'bg-blue-100',
      iconColor: 'text-blue-600',
      path: '/admin/users',
      permission: 'users'
    },
    {
      title: 'All Transactions',
      description: 'View transaction history',
      icon: BarChart3,
      iconBg: 'bg-green-100',
      iconColor: 'text-green-600',
      path: '/admin/transactions',
      permission: 'transactions'
    },
    {
      title: 'HDFC Pending',
      description: 'Manage pending HDFC UPI payments',
      icon: CreditCard,
      iconBg: 'bg-orange-100',
      iconColor: 'text-orange-600',
      path: '/admin/hdfc-pending',
      permission: 'transactions'
    },
    {
      title: 'PAN Verification',
      description: 'Verify user PAN submissions',
      icon: IdCard,
      iconBg: 'bg-amber-100',
      iconColor: 'text-amber-600',
      path: '/admin/pan-verification',
      permission: 'kyc'
    },
    {
      title: 'Data Audit',
      description: 'Find & fix balance discrepancies',
      icon: Calculator,
      iconBg: 'bg-red-100',
      iconColor: 'text-red-600',
      path: '/admin/data-audit',
      permission: 'users'
    },
    {
      title: 'Profit & Loss',
      description: 'Income, expenses & net profit',
      icon: TrendingUp,
      iconBg: 'bg-emerald-100',
      iconColor: 'text-emerald-600',
      path: '/admin/profit-loss',
      permission: 'reports'
    },
    {
      title: 'Outstanding Report',
      description: 'Customer-wise balances',
      icon: Wallet,
      iconBg: 'bg-amber-100',
      iconColor: 'text-amber-600',
      path: '/admin/outstanding',
      permission: 'reports'
    },
    {
      title: 'Daily Reports',
      description: 'Payments, refunds & redemptions',
      icon: Clock,
      iconBg: 'bg-indigo-100',
      iconColor: 'text-indigo-600',
      path: '/admin/daily-report',
      permission: 'reports'
    },
    {
      title: 'Client Ledger',
      description: 'All transactions by user & date',
      icon: FileSpreadsheet,
      iconBg: 'bg-cyan-100',
      iconColor: 'text-cyan-600',
      path: '/admin/client-ledger',
      permission: 'reports'
    },
    {
      title: 'Referral Bonus Report',
      description: "Milli's allocated via referrals",
      icon: Gift,
      iconBg: 'bg-pink-100',
      iconColor: 'text-pink-600',
      path: '/admin/referral-bonus',
      permission: 'reports'
    },
    {
      title: 'Gold Purchase Tracker',
      description: 'Track gold buying requirements',
      icon: Scale,
      iconBg: 'bg-yellow-100',
      iconColor: 'text-yellow-600',
      path: '/admin/gold-purchase-tracker',
      permission: 'reports'
    },
    {
      title: 'Notification Center',
      description: 'Send push notifications to users',
      icon: Bell,
      iconBg: 'bg-amber-100',
      iconColor: 'text-amber-600',
      path: '/admin/notifications',
      permission: 'reports'
    },
    {
      title: 'Sub-Admin Management',
      description: 'Manage sub-administrators',
      icon: Settings,
      iconBg: 'bg-purple-100',
      iconColor: 'text-purple-600',
      path: '/admin/sub-admins',
      permission: 'sub_admins'
    },
    {
      title: 'KYC Identities',
      description: 'Track linked accounts by KYC',
      icon: UserCheck,
      iconBg: 'bg-red-100',
      iconColor: 'text-red-600',
      path: '/admin/kyc-identities',
      permission: 'kyc'
    },
    {
      title: 'Employee Referrals',
      description: 'Manage employee referral codes',
      icon: UserPlus,
      iconBg: 'bg-teal-100',
      iconColor: 'text-teal-600',
      path: '/admin/employee-referrals',
      permission: 'referrals'
    }
  ];

  return (
    <div className="grid md:grid-cols-2 gap-4">
      {links.map((link, index) => {
        if (!hasPermission(link.permission)) return null;
        
        const Icon = link.icon;
        
        return (
          <Link key={index} to={link.path}>
            <Card className="border-gold/20 hover:shadow-md transition-shadow cursor-pointer">
              <CardContent className="p-4 flex items-center justify-between">
                <div className="flex items-center gap-4">
                  <div className={`w-12 h-12 ${link.iconBg} rounded-full flex items-center justify-center`}>
                    <Icon className={`w-6 h-6 ${link.iconColor}`} />
                  </div>
                  <div>
                    <p className="font-semibold text-navy">{link.title}</p>
                    <p className="text-sm text-muted-foreground">{link.description}</p>
                  </div>
                </div>
                <ChevronRight className="w-5 h-5 text-muted-foreground" />
              </CardContent>
            </Card>
          </Link>
        );
      })}
    </div>
  );
};

export default AdminQuickLinks;
